
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/disruptive",
      function () {
        return require("private-next-pages/disruptive/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/disruptive"])
      });
    }
  